import { createEntityAdapter } from '@ngrx/entity';
import { PatrimoineEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<PatrimoineEntityState>;

export const adapter = createEntityAdapter<PatrimoineEntityState>({
  selectId: o => o.idPatrimoine
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const patrimoineFeatureKey = 'patrimoine';
